import React from "react";
import axios from "axios";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import { StyledCol, StyledTableRow } from "../../../styles/styledTable";
import { StyledBreakWord } from "../../../styles/styledBreakWord";
import { StyledCopy } from "../../../styles/styledCopy";
import { TimestampToDateMoment } from "../../../../utils/timestampToDate";
import MaterialSwitch from "../../../styles/materialSwitch";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";

const TelegramManagersItem = ({ manager, onEdit, onDelete, onAttrs, onToggled, setNotification, t }) => {
  const handleToggle = () => {
    axios.patch(`/api/telegram/managers/${manager.id}/toggle-active`, {}, userAuthenticationConfig())
      .then(response => {
        if (response.status === 200) onToggled(response.data);
      })
      .catch(error => {
        setNotification({ visible: true, type: "error", message: error?.response?.data?.message || t("managers.errors.toggleActive") });
      });
  };

  return (
  <StyledTableRow scroll="auto" col="9" className="manager-list__row">
    <StyledCol data-title={t("managers.table.status")}>
      <MaterialSwitch
        checked={manager.isActive}
        onChange={handleToggle}
        label={t("managers.table.status")}
      />
    </StyledCol>
    <StyledCol data-title={t("managers.table.name")}>
      {manager.name}
    </StyledCol>
    <StyledCol data-title={t("managers.table.type")}>
      {manager.type}
    </StyledCol>
    <StyledCol data-title={t("bots.table.project")}>
      {manager.projectName || "--"}
    </StyledCol>
    <StyledCol data-title={t("managers.table.telegramId")}>
      {manager.telegramUserId ? (
        <CopyToClipboard
          text={String(manager.telegramUserId)}
          onCopy={() => setNotification({ visible: true, type: "success", message: t("common.copied") })}
        >
          <StyledBreakWord as="p">
            {manager.telegramUserId} <StyledCopy title={t("common.copy")} className="icon-light-copy" />
          </StyledBreakWord>
        </CopyToClipboard>
      ) : "--"}
    </StyledCol>
    <StyledCol data-title={t("managers.table.username")}>
      {manager.telegramUsername ? `@${manager.telegramUsername}` : "--"}
    </StyledCol>
    <StyledCol data-title={t("managers.table.email")}>
      <StyledBreakWord as="p">
        {manager.email || "--"}
      </StyledBreakWord>
    </StyledCol>
    <StyledCol data-title={t("managers.table.createdAt")}>
      {TimestampToDateMoment(manager.createdAt)}
    </StyledCol>
    <StyledCol data-title={t("managers.table.actions")}>
      <button className="table-action table-action_info" onClick={() => onAttrs(manager)}>
        <span className="icon-light-settings" />
        {t("common.attributes")}
      </button>
      <button className="table-action table-action_info" onClick={() => onEdit(manager)}>
        <span className="icon-light-edit" />
        {t("common.edit")}
      </button>
      <button className="table-action table-action_danger" onClick={() => onDelete(manager)}>
        <span className="icon-light-trash" />
        {t("common.delete")}
      </button>
    </StyledCol>
  </StyledTableRow>
  );
};

export default TelegramManagersItem;